export default "__VITE_ASSET__B48V_V0j__"